const getValue = (init = null) =>
    window.Alpine.reactive({
        _value: init,
        get value() {
            return this._value;
        },
        set value(v) {
            this._value = v;
        },
    });

export const useDepositBonus = () => {
    const bonuses = {
        _data: [],
        get value() {
            return this._data;
        },
        set value(m) {
            this._data = m;
        },
        isEmpty() {
            return this._data.length == 0;
        },
        getWelcomePackageBonus(vertical) {
            const welcomeBonuses = Object.values(this._data).filter(
                (b) => Number(b.type) === 1 // WELCOME = 1
            );

            const selectedBonus = welcomeBonuses.find((b) =>
                b.available_game_types?.includes(vertical)
            );

            return selectedBonus ?? this._data[0];
        },
    };

    const playerHasActiveBonus = getValue(false);
    const showOverview = getValue(false);

    const selected = getValue();

    const getOverview = (message, amount) => {
        if (selected.value) {
            const store = window.Alpine.store("currency");
            const bonusAmount = store.format(
                Math.min(
                    (amount ?? 0) * (selected.value.percentage / 100),
                    selected.value.max_bonus
                ),
                { digit: 0 }
            );
            return message.replace(":amount", bonusAmount);
        }
    };

    const detect = (vertical, hasDeposits) => {
        selected.value = null;

        if (playerHasActiveBonus.value || bonuses.isEmpty()) {
            return false;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const bonus_id = Number(urlParams.get("bonus_id", 0));
        if (bonus_id > 0 && bonuses.value) {
            const _detected = Object.values(bonuses.value).find(
                (b) => b.id == bonus_id
            );
            if (_detected) {
                selected.value = _detected;
                return true;
            }
        }
        if (vertical === null || vertical === undefined || vertical === "") {
            return false;
        }

        selected.value = hasDeposits
            ? bonuses.value[0]
            : bonuses.getWelcomePackageBonus(Number(vertical));
        return true;
    };

    return {
        bonuses,
        selected,
        playerHasActiveBonus,
        showOverview,
        getOverview,
        detect,
    };
};
